import React, { FC } from 'react';
import classnames from 'classnames';
import Checkbox from '@src/components/Checkbox';
import { Image } from '@src/components/Image';
import { useGetOpeningReachQuery } from '@src/graphql/generated';
import { NotificationPackageOptions, SelectNotificationPackageProps } from './props';
import './styles.scss';

export const SelectNotificationPackage: FC<SelectNotificationPackageProps> = ({
  openingId,
  priceInEur,
  selectedPackage,
  onSelectPackage,
}) => {
  const { data } = useGetOpeningReachQuery({
    variables: {
      id: openingId,
    },
  });

  return (
    <>
      <div
        className={classnames(
          'select-notification-package',
          selectedPackage === NotificationPackageOptions.PREMIUM && 'select-notification-package--selected',
        )}
        onClick={() => {
          onSelectPackage(NotificationPackageOptions.PREMIUM);
        }}
      >
        <div className="select-notification-package__header">
          <Checkbox
            style="highlighted"
            value={selectedPackage === NotificationPackageOptions.PREMIUM}
            disableStateChange
            propagateEvent
          />
          <div className="select-notification-package__header-title">
            <h4>
              Notify up to <span>{data?.opening.reach.local} matching talents</span> by e-mail and push notification.
            </h4>
            <p>
              We send out direct notifications about your job offer to the expanded audience. This feature secures that
              your job offer always stands out.
            </p>
          </div>
          <div className="select-notification-package__header-price">
            <span>€{priceInEur}</span>
            <span>/mo</span>
          </div>
        </div>

        <Image src="https://meetfrank-static-media.s3.amazonaws.com/images/notification-preview.jpg" />
      </div>
      <div
        className="select-notification-package__header-decline"
        onClick={() => {
          onSelectPackage(NotificationPackageOptions.SKIPPED);
        }}
      >
        <Checkbox value={selectedPackage === NotificationPackageOptions.SKIPPED} disableStateChange propagateEvent />
        <div className="select-notification-package__header-title">
          <h4>No, I don’t want my job opening distributed by notifications</h4>
          <p>Your job opening will still be discoverable and users can search for it.</p>
        </div>
      </div>
    </>
  );
};
